<template>
  <div>
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="8">
          <el-form-item label="難易程度" prop="level">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <vue-dividing-line title="內容及答案"></vue-dividing-line>
      <div><i class="el-icon-warning-outline"></i> 將需要填入答案的地方以英文符號()括住。</div>
      <div><i class="el-icon-warning-outline"></i> 算術題答案有餘數時用英文符號...將商與餘數隔開。</div>
      <br/>
      <div v-if="false">
        <div class="required">第一列 *</div>
        <el-form-item label="數字" prop="num1">
          <el-input v-model="rulesForm.num1" placeholder="請輸入數字"></el-input>
        </el-form-item>

        <div class="required">第二列 *</div>
        <el-form-item label="數字" prop="num2">
          <el-input v-model="rulesForm.num2" placeholder="請輸入數字"></el-input>
        </el-form-item>

        <div class="required">運算符號 *</div>
        <el-form-item label="" >
          <el-radio-group v-model="rulesForm.sumType" size="small" class="sumType">
            <el-radio :label="its.value" v-for="(its, idx) in sumType" :key="idx">{{ its.label }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <div class="required">算術題答案 *</div>
        <el-form-item label="數字" prop="num3">
          <el-input v-model="rulesForm.num3" placeholder="請輸入數字"></el-input>
        </el-form-item>
      </div>
      <Tinymce v-model="topic" ref="Tinymce"></Tinymce>

      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { symbol } from '../plugins/directive'

import division from '../plugins/division'
import rules from "../plugins/validator";

export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce },
  data() {
    return {
      topic: '',
      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],

      rulesForm: {},
      rules: {
        ...rules,
        num1: [
          { required: true, message: '請輸入數字', trigger: 'change' }
        ],
        num2: [
          { required: true, message: '請輸入數字', trigger: 'change' }
        ],
        num3: [
          { required: true, message: '請輸入數字', trigger: 'change' }
        ],
      },
      units: [],

      sumType: [
        { label: '÷', value: 'division'}
      ],
      numList: [],
      errMsg: ''
    };
  },
  watch: {
    'topic': function (v) {
      this.strConvertDom(v)
      // console.log('topicCopy')
      // console.log(topicCopy)
    }
  },
  methods: {
    strConvertDom(data) {
      let parser = new DOMParser(),
      doc = parser.parseFromString(data, 'text/html'),
      tr = doc.querySelectorAll('tr'),
      dataArr = [],
      regex = /^((((\d)|(\(\d\)))+)|(\(\)))?$/,
      regexThree = /^((\d)|(\(\d\)))+((\.\.\.((\d)|(\(\d\)))+)?)$/
      
      this.errMsg = ''
      let i = 0
      for(; i < tr.length; i ++) {
        dataArr[i] = []
        let td = tr[i].querySelectorAll('td')
        let j = 0
        for(; j < td.length; j++) {
          dataArr[i].push(td[j].innerText)
        }
        if(j != 1) {
          this.errMsg = '表格只允許1列'
          return ;
        }
      }
      if(i != 3 ) {
        this.errMsg = '表格只允許3行'
        return ;
      }

      this.rulesForm.num1 = dataArr[0][0]
      this.rulesForm.num2 = dataArr[1][0]
      this.rulesForm.num3 = dataArr[2][0]

      console.log(this.rulesForm)

      let {num1, num2, num3} = this.rulesForm
      if(num1.trim() != '' && !regex.test(num1)) {
        this.errMsg = '第一個數位不符合要求'
        return ;
      }

      if(num2.trim() != '' && !regex.test(num2)) {
        this.errMsg = '第二個數位不符合要求'
        return ;
      }

      if(num3.trim() != '' && !regexThree.test(num3)) {
        this.errMsg = '第三個數位不符合要求'
        return ;
      }
    },
    preview() {
      let form = this.handleFromData()
      
      if(form) {
        form.type = 3
        this.$emit('preview', form)
      }
    },
    save(equation) {
      this.numList = this.handleDivision(division(equation))
    },

    /**
     * 除
     * @param {*} dataObj
     * {
     *    divisor: ['2'],
     *    list: [
     *      ['#', '6', '2'],
     *      ['1', '2', '4'],
     *      ['1', '2', '#'],
     *      ['#', '#', '4'],
     *      ['#', '#', '4'],
     *      ['#', '#', '0'],
     *    ]
     * }
     */
    handleDivision(dataObj) {
      let divisor = [], list = [],
      letter = new Array(62).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

      divisor = dataObj.divisor.map(its => ({num: its, check: letter.includes(its)}))
      list = dataObj.list.map(its => 
        its.map(item => 
          ({num: item, check: letter.includes(item)})
        )
      )
      
      return {divisor, list, numMap: dataObj.numMap}
    },
    childByVideoUrl(v) {
      this.rulesForm.videoUrl = v;
      this.$forceUpdate();
    },
    handleFromData() {
      let errMsg = this.errMsg,
      topic = this.topic
      if(errMsg || !topic) {
        this.$message.error(errMsg || '請出題')
        return false;
      }

      let form = JSON.parse(JSON.stringify(this.rulesForm)), 
      regex = /\(\d+?\)/g,
      // numObj = {0: 'first_input', 1: 'second_input', 2: 'result'},
      content = {
        first_input: form.num1,
        second_input: form.num2,
        operator: '/',
        result: form.num3,
        richText: this.topic
      }
      form.choices = []
      form.answers = []
      console.log(form)
      /**
       * 记录顺序 被除数， 商， 除数，余数
       */
      let regex2 = form.num2.match(regex)
      console.log(regex2, 'regex2')
      if(regex2) {
        for(let i = 0; i < regex2.length; i++) {
          form.answers.push({value: regex2[i].substring(1, regex2[i].length - 1)})
          form.choices.push({value: ''})
          content.second_input = content.second_input.replace(regex2[i], '()')
        }
      }

      let [shang, yushu] = form.num3.split('...')
      let regex3 = shang.match(regex)
      console.log(regex3, 'regex3')
      if(regex3) {
        for(let i = 0; i < regex3.length; i++) {
          form.answers.push({value: regex3[i].substring(1, regex3[i].length - 1)})
          form.choices.push({value: ''})
          content.result = content.result.replace(regex3[i], '()')
        }
      }

      let regex1 = form.num1.match(regex)
      console.log(regex1, 'regex1')
      if(regex1) {
        for(let i = 0; i < regex1.length; i++) {
          form.answers.push({value: regex1[i].substring(1, regex1[i].length - 1)})
          form.choices.push({value: ''})
          content.first_input = content.first_input.replace(regex1[i], '()')
        }
      }

      if(yushu) {
        let regex4 = yushu.match(regex)
        if(regex4) {
          for(let i = 0; i < regex4.length; i++) {
            form.answers.push({value: regex4[i].substring(1, regex4[i].length - 1)})
            form.choices.push({value: ''})
            content.first_input = content.first_input.replace(regex4[i], '()')
          }
        }
      }

      // this.save(form)
      // let {numList} = this
      // console.log(numList)

      // for(let i in numList.numMap) {
      //   let subscript = numList.numMap[i]
      //   for(let j in subscript) {
      //     form.answers.push({value: subscript[j]})
      //     form.choices.push({value: ''})
      //   }
      // }
      // console.log(form.answers)
      form.content = JSON.stringify(content)
      // 删除多余數据
      // delete form.num1
      // delete form.num2
      // delete form.num3
      // delete form.sumType
      console.log(form)
      return form
    },
    // 提交
    onSubmit() {
      let form = this.handleFromData()
  
      if(form) {
        this.$emit('save', form, 3, 8)
      }
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
  },
  created() {
    this.rulesForm = {
      ...this.formLabelAlign,
      num1: '',
      num2: '',
      num3: '',
      sumType: 'division'
    }
  },
  mounted() {
    if(this.rulesForm.id) {
      let {first_input, second_input, result, richText} = JSON.parse(this.rulesForm.content)

      this.topic = richText
      this.rulesForm.num1 = first_input
      this.rulesForm.num2 = second_input
      this.rulesForm.num3 = result

      let regex = /\(\)/g
      let regex1 = first_input.match(regex)
      let regex2 = second_input.match(regex)
      let regex3 = result.match(regex)

      if(regex1) {
        for(let i = 0; i < regex1.length; i++) {
          first_input = first_input.replace(regex1[i], `(${this.rulesForm.answers[0].value})`)
          this.rulesForm.answers.splice(0, 1)
        }
        this.rulesForm.num1 = first_input
      }
      
      if(regex2) {
        for(let i = 0; i < regex2.length; i++) {
          second_input = second_input.replace(regex2[i], `(${this.rulesForm.answers[0].value})`)
          this.rulesForm.answers.splice(0, 1)
        }
        this.rulesForm.num2 = second_input
      }

      if(regex3) {
        for(let i = 0; i < regex3.length; i++) {
          result = result.replace(regex3[i], `(${this.rulesForm.answers[0].value})`)
          this.rulesForm.answers.splice(0, 1)
        }
        this.rulesForm.num3 = result
      }

    }
  }
};
</script>

<style lang="scss" scoped>
  input[type="number"] {
    outline: none;
    width: 70px;
    height: 32px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    padding: 0 10px;
    margin-right: 10px;

    &:focus {
      border-color: #409EFF;
    }
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
  .select {
    width: 70px;
    margin-right: 10px;
  }

  .equal {
    margin-right: 10px;
  }

  .random-choice {
    width: 100%;

    .random-single {
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      .wave {
        margin-right: 10px;
      }
    }

    .random-single:nth-last-of-type(1) {
      margin-bottom: 0;
    }
  }

  .sum-region {
    margin-top: 20px;

    $block: 40px;
    $size: 18px;
    $margin: 5px;

    .num, .empty {
      width: $block;
      height: $block;
      box-sizing: border-box;
      border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: $margin;
      font-size: $size;
    }

    .num:hover {
      background-color: #ffcca4;
    }

    .num-select {
      background-color: #ffcca4;
    }
    .canvas {
      padding: 10px;
      box-sizing: border-box;
      
      .num-item {
        width: fit-content;
        padding-left: $block;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: $margin;

        .symbol {
          width: $block;
          height: $block;
          box-sizing: border-box;
          border-radius: 3px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: $margin;
          font-size: $size;
        }

        .fill {
          width: $block;
          height: $block;
          min-width: auto;
          box-sizing: border-box;
          border-radius: 3px;
          outline: none;
          background-color: #fcd2ab;
          border: none;
          text-align: center;
          font-size: $size;
          padding: 0;
          margin-left: $margin;
        }
      }
      .num-item:nth-of-type(2) {
        margin-bottom: 10px;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          width: 102%;
          height: 1px;
          background-color: #333;
          bottom: -5px;
          left: 0;
        }

        .symbol {
          position: absolute;
          border: none;
          left: 0;
          top: 0;
          margin: 0;
          cursor: default;
        }
      }
    }
    .division {
      display: flex;
      align-content: flex-start;
      margin-top: 20px;

      .divisor {
        width: fit-content;
        height: 2 * $block;
        display: flex;
        align-items: flex-end;
        margin-right: 20px;
        margin-top: $margin;
      }
      .discuss {
        width: fit-content;
        .single {
          width: fit-content;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: $margin;
        }

        .single:nth-of-type(2n - 1) {
          position: relative;
          
          &:before {
            content: '';
            position: absolute;
            bottom: calc($margin / -2);
            left: 0;
            width: 100%;
            height: 1px;
            background-color: #333;
          }
        }

        .division-style {
          position: absolute;
          width: 20px;
          height: 50px;
          top: calc(100% + $margin / 2);
          left: -20px;
          overflow: hidden;

          &:before {
            content: '';
            position: absolute;
            border-radius: 50%;
            box-sizing: border-box;
            top: -80px;
            left: -60px;
            width: 80px;
            height: 160px;
            border: 1px solid #333;
            border: none;
            border-right: 1px solid #333;
            border-bottom: 1px solid #333;
          }
        }
      }
    }
  }
</style>